<template>

<div>
  <LDBsTable
    url="arena/versions"
    defaultSort="id"
    defaultOrder="asc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="id">{{ $t('id') }}</label>
      <input
        type="text"
        id="id"
        name="id"
        class="form-control"
        :placeholder="$t('ph_id')"
        v-model="query.id"
        @input="upper('id')"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="description">{{ $t('description') }}</label>
      <input
        type="text"
        id="description"
        name="description"
        class="form-control"
        :placeholder="$t('ph_description')"
        v-model="query.VER_DSC"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="code">{{ $t('code') }}</label>
      <input
        type="text"
        id="code"
        name="code"
        class="form-control"
        :placeholder="$t('ph_code')"
        v-model="query.VER_COD"
      >
    </div>
  </LDBsTable>
</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import { mapState } from 'vuex'

export default {
  name: 'ArenaEquipmentVersionList',

  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('ID'),
          field: 'id',
          sortable: true
        },
        {
          title: this.$t('description'),
          field: 'VER_DSC',
          sortable: false
        },
        {
          title: this.$t('code'),
          field: 'VER_COD',
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `
              <a
                href="#/main/arena/equipment-version/${value}"
                class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-pen" />
              </a>
            `
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'arena_versao_equipamento' }
      },
      queryToUse: {},
      query: {
        id: '',
        VER_DSC: '',
        VER_COD: ''
      }
    }
  },

  computed: {
    ...mapState({
      lastquery: state => state.filtershistory.query,
      contracts: state => state.contracts.all,
      clients: state => state.arena.clients,
      equipmentVersions: state => state.arena.equipmentVersions,
    })
  },

  methods: {
    clear() {
      this.query.id = ''
      this.query.VER_DSC = ''
      this.query.VER_COD = ''
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase()
    },
  },

  beforeMount() {
    this.queryToUse = this.lastquery['arenaequipmentversion'] ? this.lastquery['arenaequipmentversion'] : this.query
  },

  async mounted () {
    const { dispatch } = this.$store

    await Promise.all([
      dispatch('arena/fetchArenaEquipmentVersions'),
      dispatch('arena/fetchClients')
    ])

    if (this.lastquery['arenaequipmentversion']) {
      for (const [key, value] of Object.entries(this.lastquery['arenaequipmentversion'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query
  },

  destroyed () {
    this.$store.dispatch(
      'filtershistory/setQuery',
      {
        key: 'arenaequipmentversion',
        query: this.query
      }
    )
  },
}

</script>
